// Angular Files
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Teller Online Payment Processor Integration Files
import { AuthorizationConsentModule } from 'apps/public-portal/src/app/shared/components/authorization-consent/authorization-consent.component';
import { PaymentConsentDialogModule } from 'apps/public-portal/src/app/shared/components/payment-consent-dialog/payment-consent-dialog.module';
import { BillingInfoModule } from './billing-info/billing-info.component';
import { ECheckModule } from './echeck/echeck.component';
import { PaymentIntegrationFormFieldModule } from './payment-integration-form-field/payment-integration-form-field.component';
import { TestTriggerModule } from './test-trigger/test-trigger.component';

@NgModule({
    imports: [
        CommonModule,
        BillingInfoModule,
        TestTriggerModule,
        ECheckModule,
        PaymentIntegrationFormFieldModule,
        AuthorizationConsentModule,
        PaymentConsentDialogModule
    ],
    exports: [
        BillingInfoModule,
        TestTriggerModule,
        ECheckModule,
        PaymentIntegrationFormFieldModule,
        AuthorizationConsentModule,
        PaymentConsentDialogModule
    ]
})
export class BasePaymentProcessorIntegrationsModule { }
